import React from 'react'

import { SortDrawer } from 'components/UI/SortDrawer'
import type { SortOption, SortEntry, SortDrawerProps } from 'components/UI/SortDrawer'

/**
 * Scans sort — the field list, and nothing else.
 *
 * The sheet itself is `components/UI/SortDrawer`. This file used to carry its own
 * ~180-line copy of it; the copies differed only in this list.
 *
 * This was the ONLY one of the four that declared field types, so it is the one
 * surface whose Date sort already read correctly.
 */
export type ScansSortField = 'owner_name' | 'status' | 'date' | 'location'
export type ScansSortDirection = 'ASC' | 'DESC'
export type AdditionalScansSort = SortEntry<ScansSortField>

const OPTIONS: SortOption<ScansSortField>[] = [
  { key: 'owner_name', label: 'Owner name', type: 'string' },
  { key: 'status', label: 'Status', type: 'string' },
  { key: 'date', label: 'Date', type: 'dateTime' },
  { key: 'location', label: 'Location', type: 'string' },
]

export type ScansSortDrawerProps = Omit<SortDrawerProps<ScansSortField>, 'options'>

export const ScansSortDrawer: React.FC<ScansSortDrawerProps> = props => (
  <SortDrawer<ScansSortField> {...props} options={OPTIONS} />
)

export default ScansSortDrawer
